export { default } from "./Footnote";
